<template>
  <div id="property-history" class="table-responsive">
    <table class="table table-sm table-striped table-hover table-bordered">
      <thead>
        <tr>
          <th scope="col">Event</th>
          <th scope="col">Date</th>
          <th scope="col">Effective Date</th>
          <th scope="col">Create Year</th>
          <th scope="col">Related Parcel Number</th>
          <th scope="col">Book</th>
          <th scope="col">Page</th>
          <th scope="col">Doc Nbr</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!items.length">
          <td colspan="9" class="text-center text-muted p-3">
            No data
          </td>
        </tr>
        <tr v-for="(item, index) in items" v-bind:key="index">
          <td>
            {{ eventTypes[item.HISTORYEVENT.trim().toUpperCase()] || "" }}
          </td>
          <td>{{ item.HISTORYDATE | toDate }}</td>
          <td>{{ item.EFFECTIVEDATE | toDate }}</td>
          <td>{{ item.PayYear }}</td>
          <td>
            <a
              :href="searchRelatedUrl(item.RELATEDSTATEKEY, item.PayYear)"
              rel="noopener"
              target="_blank"
              >{{ item.RELATEDSTATEKEY }}</a
            >
          </td>
          <td>{{ item.RECORDERSBOOK || "No Info" }}</td>
          <td>{{ item.RECORDERSPAGE || "No Info" }}</td>
          <td>{{ item.RECORDERSDOCNBR || "No Info" }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      eventTypes: {
        A: "Annexation (Removed)",
        A2: "New by Annexation",
        C: "Combined (Removed)",
        C2: "Combined (Kept)",
        S: "Split (Original)",
        S2: "New from Split",
        N: "New (Created)",
      },
    };
  },
  methods: {
    searchRelatedUrl: function(key, payYear) {
      return `${process.env.BASE_URL}${this.countySlug}?parcelNumber=${key}&showPastInactive=true&payYear=${payYear}`;
    },
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    countySlug: {
      type: String,
      required: true,
    },
  },
};
</script>
